export const LOCAL_DOMAIN = 'ui.docker.internal';
